import { OperatorRole } from '../../pm/types';
import { OPERATOR_ROLE_LABELS } from '../../pm/constants';

interface Props {
  role?: OperatorRole;
}

const OperatorRoleBadge: React.FC<Props> = ({ role }) => {
  if (!role) return <span className="pm-op-badge pm-op-unset">Unset</span>;
  return <span className={`pm-op-badge pm-op-${role}`}>{OPERATOR_ROLE_LABELS[role]}</span>;
};

export default OperatorRoleBadge;
